const createIconStory = (args: { iconName: string; size: number; outline: boolean }) => `
    <d-icon icon="${args.iconName}" ${args.outline ? 'outline' : ''} size="${args.size}"/>
`;

const meta = {
  title: 'Design System/MEDIA & ICONS/Icons',
};

export default meta;

export const ArrowBackOutline = {
  args: {
    iconName: 'arrow-back',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const ArrowForwardOutline = {
  args: {
    iconName: 'arrow-forward',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Check = {
  args: {
    iconName: 'check',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Close = {
  args: {
    iconName: 'close',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Copy = {
  args: {
    iconName: 'copy',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Done = {
  args: {
    iconName: 'done',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Help = {
  args: {
    iconName: 'help',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const HomeOutline = {
  args: {
    iconName: 'home',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Home = {
  args: {
    iconName: 'home',
    size: 24,
    outline: false,
  },
  render: createIconStory,
};

export const Key = {
  args: {
    iconName: 'key',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Language = {
  args: {
    iconName: 'language',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Lock = {
  args: {
    iconName: 'lock',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Logout = {
  args: {
    iconName: 'logout',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const More = {
  args: {
    iconName: 'more',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const NotificationOutline = {
  args: {
    iconName: 'notification',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Notification = {
  args: {
    iconName: 'notification',
    size: 24,
    outline: false,
  },
  render: createIconStory,
};

export const ProfileOutline = {
  args: {
    iconName: 'profile',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Profile = {
  args: {
    iconName: 'profile',
    size: 24,
    outline: false,
  },
  render: createIconStory,
};

export const Settings = {
  args: {
    iconName: 'settings',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Shield = {
  args: {
    iconName: 'shield',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const VisibilityOff = {
  args: {
    iconName: 'visibility-off',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Visibility = {
  args: {
    iconName: 'visibility',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const WalletOutline = {
  args: {
    iconName: 'wallet',
    size: 24,
    outline: true,
  },
  render: createIconStory,
};

export const Wallet = {
  args: {
    iconName: 'wallet',
    size: 24,
    outline: false,
  },
  render: createIconStory,
};
